/**
 * SOLOMON — LOGIN PAGE
 * Phase 1 / Day 9: Login & Authentication
 *
 * Private access only — login screen for Justin.
 * No registration UI. Accounts are created server-side only.
 * Responsive for mobile and desktop.
 */

import { useState, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import './login.css';

// ============================================================
// INPUT COMPONENT
// ============================================================

function AuthInput({ label, type = 'text', value, onChange, placeholder, autoComplete }) {
  return (
    <div className="login-field">
      <label className="login-label">{label}</label>
      <input
        className="login-input"
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
    </div>
  );
}

// ============================================================
// LOGIN FORM
// ============================================================

function LoginForm() {
  const { login } = useAuth();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      // AuthContext sets user → App.jsx re-renders to Solomon
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [email, password, login]);

  const ready = email.trim() && password;

  return (
    <form onSubmit={handleSubmit} noValidate>
      {error && <div className="login-error">{error}</div>}

      <AuthInput
        label="Email"
        type="email"
        value={email}
        onChange={setEmail}
        placeholder="you@example.com"
        autoComplete="email"
      />
      <AuthInput
        label="Password"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder="••••••••"
        autoComplete="current-password"
      />

      <button
        type="submit"
        className="login-submit"
        disabled={loading || !ready}
      >
        {loading ? 'Authenticating…' : 'Access Solomon'}
      </button>
    </form>
  );
}

// ============================================================
// MAIN LOGIN PAGE
// ============================================================

export default function LoginPage() {
  return (
    <div className="login-overlay">
      <div className="login-card">

        {/* Logo */}
        <div className="login-logo">
          <div className="login-orb" />
          <div className="login-title">SOLOMON</div>
          <div className="login-sub">AI Command Center</div>
        </div>

        <div className="login-divider" />

        <LoginForm />

        <p className="login-hint">
          Private access · By invitation only
        </p>
      </div>
    </div>
  );
}
